import React, { useState, useCallback} from "react";

import Box from "@mui/material/Box";
import ListItem from "@mui/material/ListItem";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import StopInfoBlock from "../StopInfoBlock";
import StopNameBlock from "../StopNameBlock";
import AddStopButton from "../AddStopButton";
import StopInfoModal from "../Modals/StopInfoModal";

import checkIcon from "../../assents/img/check.svg";
import backetIcon from "../../assents/img/basket.svg";
import { BACKEND_URL } from "../../constans";

const Wrapper = styled(ListItem, {
  shouldForwardProp: (propName) => propName !== "isModal",
})(({ theme, isModal }) => ({
  padding: 0,
  marginBottom:'50px',
  borderRadius: "10px",
  background: "#ffffff",
  width: "335px",
  display: "block",
  boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.2)",
  boxSizing: "border-box",
  "&:not(:last-child)": {
    ...(isModal
      ? null
      : {
          marginBottom: "30px",
        }),
  },
  [theme.breakpoints.up("sm")]: {
    width: "440px",
    height: "426px",
  },
}));

const ImgWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  boxSizing: "border-box",
  width: "335px",
  height: "224px",
  borderTopLeftRadius: "10px",
  borderTopRightRadius: "10px",
  cursor: "pointer",
  [theme.breakpoints.up("sm")]: {
    width: "440px",
    height: "294px",
  },
}));

const StopImg = styled("img")(({ theme }) => ({
  width: "335px",
  height: "224px",
  borderTopLeftRadius: "10px",
  borderTopRightRadius: "10px",
  objectFit: "cover",
  [theme.breakpoints.up("sm")]: {
    width: "440px",
    height: "294px",
    objectFit: "initial",
  },
}));

const ImgBackground = styled(Box)(() => ({
  height: "150px",
  position: "absolute",
  opacity: 0.7,
  width: "100%",
  bottom: "0",
  background: "linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 100%)",
}));

const DescriptionWrapper = styled(Box)(() => ({
  width: "100%",
  padding: "14px 20px 19px",
  textAlign: "left",
  boxSizing: "border-box",
}));

const StopDescription = styled(Typography)(() => ({
  fontFamily: "Proxima Nova",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: 1.5,
  color: "#1a1a1a",
  minHeight: "48px",

  "& span": { color: "#2bb656", cursor: "pointer" },
}));

const ManageStopWrap = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginTop: "12px",
  [theme.breakpoints.up("sm")]: {
    marginTop: "19px",
  },
}));

const AddedWrap = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "120px",
  height: "32px",
  padding: "8px",
  background: "rgba(43, 182, 86, 0.1)",
  borderRadius: "100px",
  boxSizing: "border-box",
  [theme.breakpoints.up("sm")]: {
    width: "111px",
  },
}));

const AddedText = styled(Typography)(() => ({
  fontFamily: "Proxima Nova",
  fontWeight: "bold",
  fontSize: "14px",
  lineHeight: 1.214,
  color: "#2bb656",
}));

const RemoveWrap = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "115px",
  height: "28px",
  marginLeft: "10px",
  padding: "8px",
  boxSizing: "border-box",
  cursor: "pointer",
}));

const RemoveText = styled(Typography)(() => ({
  fontFamily: "Proxima Nova",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: 1.214,
  color: "#1a1a1a",
  opacity: 0.5,
}));

const StopCard = ({
  stop,
  total,
  tourDefaultPrice,
  isFromAddedStations,
  removeStation,
  addStation,
  setClickAdd,
  handleClose,
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  
  const handleAddStop = useCallback(() => {
    addStation(stop);
    setClickAdd(true)
    handleClose();
  }, [stop, addStation, handleClose]);
 
  const handleOpenModal = useCallback(() => setModalIsOpen(true), []);

  const handleCloseModal = useCallback(() => setModalIsOpen(false), []);

  return (
    <>
      <Wrapper isModal={!removeStation}>
        <ImgWrapper onClick={handleOpenModal}>
          <StopImg
            src={stop.images ? `${BACKEND_URL}${stop.images[0]}` : ""}
            alt={stop.name}
            width="440px"
            height="294px"
          />

          <ImgBackground />
          <StopInfoBlock
          priceMinute={stop.price_minute}
            total={total}
            tourDefaultPrice={tourDefaultPrice}
            duration={stop.duration}
            priceAdult={stop.price_adult}
            priceChild={stop.price_child}
            priceInfant={stop.price_infant}
          />
          <StopNameBlock placeType={stop.place_type} name={stop.name} />
        </ImgWrapper>
        <DescriptionWrapper>
          {stop.short_description && (
            <StopDescription>
              {stop.short_description}
              <span onClick={handleOpenModal}> Read more ›</span>
            </StopDescription>
          )}
          {removeStation ? (
            <ManageStopWrap>
              <AddedWrap>
                <img src={checkIcon} alt="check icon" />
                <AddedText>Stop added</AddedText>
              </AddedWrap>
              <RemoveWrap onClick={() => removeStation(stop.id)}>
                <img src={backetIcon} alt="basket icon" />
                <RemoveText>Remove stop</RemoveText>
              </RemoveWrap>
            </ManageStopWrap>
          ) : (
            <AddStopButton handleClick={handleAddStop} isModal />
          )}
        </DescriptionWrapper>
      </Wrapper>
      <StopInfoModal
        stop={stop}
        open={modalIsOpen}
        handleClose={handleCloseModal}
        isFromAddedStations={isFromAddedStations}
        handleClick={handleAddStop}
      />
    </>
  );
};

export default StopCard;
